import React from 'react';
import './Message.css'

const Message = ({ author, date, children, erreur }) => {
    const nameClass = author === "user" ? "player" : (author === "system" ? "system" : "ordi")

    //replace url by link but the link doesn't to have a point at the end exemple : 'salut c'est moi https://www.google.com.' replaces by <a href="https://www.google.com> https://www.google.com</a>
    var text = children.replace(/(https?:\/\/[^\s]+)/, function (url) {
        var lastURL = url.match(/^(.*)\./).slice(-1)

        return '<a href="' + lastURL + '" target=”_blank”>' + url + '</a>';
    });
    // var text = children.replace(/(https?:\/\/[^\s]+)/g, function (url) {">' + url + '</a>
    //     return '<a href="' + url + '">' + url + '</a>';
    // });

    return (
        // To do
        <div className={'message-container ' + nameClass}>
            <div className='message'>
                <div dangerouslySetInnerHTML={{ __html: text }} />
            </div>
            {erreur ?
                (<div className='erreur'>
                    Erreur : Forfait épuisé
                </div>) :
                (<div className="date">
                    {date}
                </div>)}
        </div>

    );
}

export default Message